export default __webpack_public_path__ + "d5bed99242462f22bb6f413216bde43a.jpg";